import { FC } from "react";
import { Outlet } from "react-router-dom";

const OrgMgmt: FC = () => {
  return <Outlet />;
};
export default OrgMgmt;
